import OmegaTracker from '@didi/omega-tracker'
import { env, getOSInfo } from '@/utils'

const NODE_ENV = process.env.NODE_ENV
const IS_PRO = NODE_ENV === 'production'
// const IS_PRO = true
const OS_TYPE_JSON = {
  window: 9,
  mac: 10,
  android: 2,
  ios: 1,
  default: -1,
}

function omegaSetConfig() {
  const userInfo = env.get('userInfo')
  OmegaTracker.setConfig({
    appKey: 'omega5c0fa368a5',
    autoPosition: false,
    uploadHost: 'omgup.didiglobal.com',
    locale: userInfo.locale,
    countryCode: userInfo.country,
    userName: userInfo.username,
    userId: userInfo.username,
    autoSendPageView: false,
    attrs: {
      id: userInfo.id,
      email: userInfo.email,
      timezone: userInfo.timezone,
      country: userInfo.country,
      username: userInfo.username,
      // 设备和业务信息 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=272905834
      osType: OS_TYPE_JSON[getOSInfo() || 'default'],
      businessType: 5, // 内部业务类型 1:r, 2:c, 3:b, 4:bd, 5:m
      brand: 2, // 外卖品牌类型 1:滴滴外卖，2:didi Food，3:99 Food
      terminalType: 5, // 端类型信息 1：独立端 5：web
    },
  })
}

const devTraceEvent = (...args) => {
  if (process.env.VUE_APP_TRACE_EVENT === 'ON') {
    console.log(`${'-'.repeat(10)}测试环境屏蔽埋点,埋点数据${'-'.repeat(10)}`)
    console.log(...args)
  }
}
// 导出统计方案
const Omega = IS_PRO ? OmegaTracker : { trackEvent: devTraceEvent }
const trackEvent = IS_PRO ? Omega.trackEvent.bind(Omega) : devTraceEvent
// 导出内置mixin组件
const vuePlugin = {
  install: Vue => {
    Vue.mixin({
      methods: {
        $_crm_trackEvent: trackEvent,
      },
    })
  },
}
// 兼容历史错误写法
const Omege = Omega
export { Omega, Omege, trackEvent, vuePlugin, omegaSetConfig }
